export interface PushProgress {
  uuid?: string;
  principal?: string;
  auxiliar?: string;
  logo?: string;
}

export class PushConfirme{
  uuidRodada?: string;
  uuid?: string;
  startup?: string;
  valorInvestimento?: number;
  nomeInvestidor?: string;
}
